<div class="modal-container popup-general modal-sm percent_35
 row p-0 mt-4">
  <div class="modal-container-header col-12">
    <span>{{ title | translate}}</span>
    <span class="k-icon k-i-close" (click)="closeModal('cancelar')" *ngIf="aspa"></span>
  </div>


  <div class="modal-container-section col-12">
    <div class="col-12">
      <p>{{ message | translate }}</p>
    </div>

    <div class="modal-footer p-0">

      <button *ngIf="isButtonOk" type="button" class="btn btn-secondary  verde_con_efecto border_all"
        (click)="closeModal('aceptar')" #focus>
        <span *ngIf="!isIconOk" class="k-icon k-i-check-outline
          k-i-checkmark-outline text-size-big"></span>
        {{ textButtonOk | translate}}
      </button>

      <button *ngIf="isButtonCancel" type="button" class="btn btn-secondary float-right  rojo_con_efecto"
        (click)="closeModal('cancelar')">
        <span *ngIf="!isIconCancel" class="k-icon k-i-close-outline
          k-i-x-outline  text-size-big"></span>
        {{ textButtonCancel | translate}}
      </button>

    </div>
  </div>

</div>